<template>
  <acknowledge :headline="headline">
    <template slot="image">
      <img class="eat" alt="eat" src="../../assets/images/eat-category-icon.svg"/>
    </template>
    <template slot="message">
      <p>Your request for a trial subscription has been sent!<br />
        Thank you for your interest in Lerner Maker Lab!</p>
    </template>
  </acknowledge>
</template>

<script>
  import Acknowledge from '@/component/Acknowledge';

  export default {
    name: 'RegisterAcknowledge',

    components: {
      Acknowledge,
    },

    data: function () {
      return {
        headline: 'Tasty!',
      }
    }
  };
</script>